import React from "react";
import styles from "./styles.module.scss";
import { AwaitingInstallIcon } from "../../Styles/Icons/DesignSystem/AwaitingInstallIcon";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";

const AwaitingInstallButton = ({
  numberAwaitingInstall,
  setSelectedFilter,
  setSelectedTab,
}) => {
  const numAwaitingInstall =
    numberAwaitingInstall > 0
      ? `${numberAwaitingInstall} Users awaiting install`
      : "No users awaiting install";

  const track = useAmplitudeTracking();

  return (
    <div
      className={styles.awaiting_install_button_container}
      onClick={() => {
        setSelectedTab("users");
        setSelectedFilter("incomplete");
        track("Service User Browsing", {
          action_type: "filter",
          filter_type: "installation_incomplete",
          location: "dashboard",
          button_type: "awaiting_install",
        });
      }}
    >
      <div className={styles.awaiting_install_icon_container}>
        <AwaitingInstallIcon />
      </div>
      <div className={styles.awaiting_install_text_content_container}>
        <div className={styles.awaiting_install_text}>{numAwaitingInstall}</div>
        <div className={styles.click_to_view_text}>Click to view</div>
      </div>
    </div>
  );
};

export default AwaitingInstallButton;
